/**
 * Adresse d'inscription newsletter — côté CRM, comme tout le reste des API.
 *
 * Les deux formulaires (modale + bloc « Rester informé ») postaient vers une
 * adresse de démonstration écrite en dur, héritée du modèle : aucune
 * inscription n'arrivait jamais au CRM. Ils lisent désormais la même variable
 * que les autres appels du site (`NEXT_PUBLIC_ADMIN_API_URL`, figée au build).
 */
const ADMIN_API = (process.env.NEXT_PUBLIC_ADMIN_API_URL || 'https://admin.example.com').replace(/\/$/, '')

export const NEWSLETTER_SUBSCRIBE_URL = `${ADMIN_API}/api/newsletter/subscribe`
